module.exports = __webpack_public_path__ + "img/fiberapi.2ade8be0.jpg";